import { attribute, create, clickable, collection, text, visitable } from 'ember-cli-page-object';
import VCLink from '../../vc-link';
import flashMessage from 'core/test-support/pages/components/flash-message';
export default create({
  visit: visitable('/private/registries/reclaim/'),
  stepper: {
    scope: '.hds-stepper-nav'
  },
  linkStep: VCLink(),
  reclaimStep: {
    scope: '[data-test-step-reclaim]',
    registries: collection('[data-test-registries] tbody tr', {
      isSelected: attribute('checked', 'th:eq(0) input'),
      select: clickable('th:eq(0) input'),
      name: text('td:eq(0) span'),
      createdAt: text('td:eq(1)'),
      boxCount: text('td:eq(2)')
    }),
    openProjects: clickable('.hds-form-super-select .ember-power-select-trigger'),
    projects: collection('.hds-form-super-select .ember-power-select-option', {
      name: text(),
      select: clickable()
    }),
    async setProject(project) {
      await this.openProjects();
      const opt = this.projects.findOneBy('name', project);
      await opt.select();
    },
    submit: {
      scope: '.hds-button-set button.hds-button--color-primary'
    },
    goBack: {
      scope: '.hds-button-set button.hds-button--color-secondary'
    }
  },
  flash: flashMessage
});